export function generateDataUrlDownload(data, filename, mimeTypeString) {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = "".concat(mimeTypeString !== null && mimeTypeString !== void 0 ? mimeTypeString : 'data:text/csv;charset=utf-8', ",").concat(encodeURIComponent(data));
  hiddenElement.target = '_blank';
  hiddenElement.download = filename;
  hiddenElement.click();
}